import { Area, AreaContent } from "../../useAreas/areas/types";
import hero from "../../../../assets/image/areas/hero/handelsUndGesellschaftsrecht.webp";

const data: AreaContent = {
  id: Area.HANDELUNDGESELLSCHAFTSRECHT,
  hero: hero,
  content: [
    "Wir beraten Unternehmen, Unternehmer:innen, Gesellschafter:innen und Geschäftsführer:innen in allen wesentlichen Fragen des Handels- und Gesellschaftsrechts.",
    "Dabei begleiten wir Sie von der Gründung und Vertragsgestaltung über die laufende Beratung bis hin zu Umstrukturierungen, Auseinandersetzungen und Nachfolgeregelungen.",
    "<strong>Gesellschaftsrecht</strong>",
    "Wir beraten Sie bei der Gründung einer Gesellschaft, unterstützen Sie bei deren Leitung und laufender Beteiligung und vertreten Sie bei der Auflösung oder beim Ausscheiden aus einer Gesellschaft.",
    "Wir stehen Ihnen insbesondere beratend zur Seite bei:",
    [
      "der Rechtsformwahl",
      "Rechtsformänderungen und Umstrukturierungen",
      "der Gestaltung von Gesellschaftsverträgen",
      "Existenzgründungen",
      "Satzungsänderungen",
      "der Anfechtung von Gesellschafterbeschlüssen",
      "dem Abschluss, der Änderung und Beendigung von Geschäftsführeranstellungsverträgen",
      "der Geschäftsführung und Vertretung in Personengesellschaften, insbesondere oHG, KG, GbR und eGBR",
      "der Auflösung und Auseinandersetzung einer Gesellschaft",
      "der Vererbung von Gesellschaftsanteilen und Unternehmensnachfolge",
    ],
    "<strong>Handelsrecht</strong>",
    "Im Handelsrecht beraten wir Sie insbesondere bei:",
    [
      "Fragen zum Recht des Handelsstandes, insbesondere Kaufmannseigenschaft, Firmenrecht und HGB",
      "der Wahl geeigneter Vertriebsformen",
      "der Gestaltung von Vertriebsverträgen",
      "Handelsgeschäften, Handelsbräuchen und Handelskauf",
      "der Gestaltung von AGB unter Kaufleuten",
      "insolvenzrechtlichen Fragestellungen",
    ],
  ],
  bullets: [
    "Vertragsgestaltung",
    "Gesellschaftsgründungen und Umstrukturierungen",
    "Rechtsformwahl",
    "Gesellschaftsverträge",
    "Satzungsänderungen",
    "Anfechtung von Gesellschafterbeschlüssen",
    "Geschäftsführeranstellungsverträge",
    "Personengesellschaften, insbesondere oHG, KG, GbR und eGBR",
    "Handelsrecht und HGB",
    "Vertriebsverträge",
    "AGB unter Kaufleuten",
    "Insolvenzrecht",
  ],
  more: [],
};

export default data;
